/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_no_invitations_with_filters = /** @type {(inputs: {}) => string} */ () => {
	return `No se encontraron invitaciones con los filtros aplicados.`
};

const en_persons_no_invitations_with_filters = /** @type {(inputs: {}) => string} */ () => {
	return `No invitations found with applied filters.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_no_invitations_with_filters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_no_invitations_with_filters(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_no_invitations_with_filters", locale)
	if (locale === "es") return es_persons_no_invitations_with_filters(inputs)
	return en_persons_no_invitations_with_filters(inputs)
};
export { persons_no_invitations_with_filters as "persons.no_invitations_with_filters" }